import React from "react";
import { ReactNode } from "react";
import { Box, Stack, Flex, Text } from "@chakra-ui/react";
interface IFees {
  showTransferAmount?: boolean;
  transferAmount?: number;
  transferAmountSymbol?: string;
  relayFee?: number;
  relayFeeSymbol?: string;
  showGreenFee: boolean;
  greenFee?: number;
  greenFeeSymbol?: string;
}

const Fees: React.FC<IFees> = ({
  showTransferAmount,
  transferAmount,
  transferAmountSymbol,
  relayFee,
  relayFeeSymbol,
  showGreenFee,
  greenFee,
  greenFeeSymbol,
}: IFees) => {
  return (
    <Box>
      <Box as={Stack} spacing="16px" direction={"column"} mt="32px" mb="50px">
        <FeeDisplay label="Bridge Fee">
          {relayFee !== undefined && `${relayFee} ${relayFeeSymbol}`}
        </FeeDisplay>
        {showGreenFee && (
          <FeeDisplay label="Carbon Offset Fee">
            {greenFee !== undefined &&
              greenFeeSymbol !== undefined &&
              `${greenFee} ${greenFeeSymbol}`}
          </FeeDisplay>
        )}
        {showTransferAmount !== false && (
          <FeeDisplay label="Transfer Amount">
            {transferAmountSymbol !== undefined &&
              `${transferAmount?.toFixed(3)} ${transferAmountSymbol}`}
          </FeeDisplay>
        )}
      </Box>
    </Box>
  );
};

export default Fees;

interface IFeesDisplay {
  label: string;
  children?: ReactNode | ReactNode[];
}

const FeeDisplay: React.FC<IFeesDisplay> = ({
  label,
  children,
}: IFeesDisplay) => {
  return (
    <Flex justifyContent="space-between" fontSize="12px" color="brand.800">
      <Text>{label}</Text>
      <Text>{children}</Text>
    </Flex>
  );
};
